import { faReply } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  CardFooter,
} from "reactstrap";
import ButtonIcon from "../common/ButtonIcon";
import { PreloadState } from "../UI/preloading/PreloadState";
import { VE_PHONE_FORMAT } from "../../helpers/utils";

const DetailsVisitor = () => {
  const history = useHistory();
  const { state } = useLocation();
  const [data, setData] = useState({});
  const [isLoading, setLoading] = useState(true);
  const { condominium } = useSelector((state) => state.condominium);

  useState(() => {
    let isMounted = true;
    if (!!state) {
      if (!!state.visitor) {
        const loadData = () => {
          !!isMounted && setData(state.visitor);
          !!isMounted && setLoading(false);
        };
        loadData();
      }
    }
    return () => {
      isMounted = false;
    };
  }, [state]);

  return (
    <>
      <Card>
        <CardHeader className="bg-light">
          <Container>
            <Row className="align-items-center justify-content-start">
              <h5 className="mb-0">Detalles</h5>
            </Row>
          </Container>
        </CardHeader>
        <PreloadState loading={isLoading}>
          <CardBody className="border-top bg-light">
            <Row>
              <div className="col-xxl-5 col-lg">
                <h6 className="font-weight-semi-bold ls mb-3 text-uppercase">
                  Información de la cuenta
                </h6>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">ID</p>
                  </div>
                  <div className="col">{data.id}</div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">Creado</p>
                  </div>
                  <div className="col">
                    {moment(data.data?.created_at).format("DD-MM-YYYY")}
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-0">Condominio</p>
                  </div>
                  <div className="col">{condominium && condominium}</div>
                </div>
              </div>
              <div className="col-xxl-5 mt-4 mt-lg-0 offset-xxl-1 col-lg">
                <h6 className="font-weight-semi-bold ls mb-3 text-uppercase">
                  Información personal
                </h6>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">DNI</p>
                  </div>
                  <div className="col">
                    {!data.data?.dni ? (
                      <p className="font-italic text-400 mb-1">NO AGREGADO</p>
                    ) : (
                      <p className="mb-1">{data.data?.dni}</p>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">Nombre</p>
                  </div>
                  <div className="col">
                    <p className="mb-1">{data.data?.firstname}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">Apellido</p>
                  </div>
                  <div className="col">
                    <p className="mb-1">{data.data?.lastname}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">
                      Nro de teléfono
                    </p>
                  </div>
                  <div className="col">
                    {!data.data?.phone ? (
                      <p className="font-italic text-400 mb-1">NO AGREGADO</p>
                    ) : (
                      <a href={`tel:${data.data?.phone}`}>
                        <NumberFormat
                          displayType="text"
                          value={data.data?.phone}
                          format={VE_PHONE_FORMAT}
                        />
                      </a>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-0">Destino</p>
                  </div>
                  <div className="col">
                    {!data.property?.address ? (
                      <p className="font-italic text-400 mb-1">NO AGREGADO</p>
                    ) : (
                      <p className="font-weight-semi-bold mb-0">
                        {data.property?.address}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </Row>
            <Row>
              <div className="col-xxl-5 mt-4 mt-lg-0 col-lg">
                <h6 className="font-weight-semi-bold ls mb-3 text-uppercase">
                  Información del propietario
                </h6>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">DNI</p>
                  </div>
                  <div className="col">
                    {!data.property?.dni ? (
                      <p className="font-italic text-400 mb-1">NO AGREGADO</p>
                    ) : (
                      <p className="mb-1">{data.property?.dni}</p>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">Nombre</p>
                  </div>
                  <div className="col">
                    <p className="mb-1">{data.property?.firstname}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">Apellido</p>
                  </div>
                  <div className="col">
                    <p className="mb-1">{data.property?.lastname}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-5 col-sm-4">
                    <p className="font-weight-semi-bold mb-1">
                      Nro de teléfono
                    </p>
                  </div>
                  <div className="col">
                    {!data.property?.phone ? (
                      <p className="font-italic text-400 mb-1">NO AGREGADO</p>
                    ) : (
                      <a href={`tel:${data.property?.phone}`}>
                        {data.property?.phone}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </Row>
          </CardBody>
          <CardFooter>
            <Row>
              <Col className="d-flex justify-content-end align-items-center">
                <ButtonIcon
                  color="light"
                  icon={faReply}
                  onClick={() => history.goBack()}
                >
                  Volver
                </ButtonIcon>
              </Col>
            </Row>
          </CardFooter>
        </PreloadState>
      </Card>
    </>
  );
};

export default DetailsVisitor;
